import React from 'react';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { SyncSelectionCapError } from '../../services/api';

export interface SyncCapNoticeProps {
  error: SyncSelectionCapError;
  onDismiss: () => void;
}

/**
 * Inline notice for a sync-selection write the plan cap refused, with the
 * limit in the copy and a link to Billing. There is no shared plan-gate
 * notice component in the frontend yet; the Sales Report's locked state also
 * just sends the store to /app/billing.
 */
export default function SyncCapNotice({ error, onDismiss }: SyncCapNoticeProps) {
  const navigate = useNavigate();
  const { t } = useTranslation() as unknown as { t: (key: string, options?: Record<string, unknown>) => string };
  const brands = error.code === 'SYNC_SELECTION_BRAND_CAP';
  const base = brands ? 'productBrowser.syncCap.brandsMessage' : 'productBrowser.syncCap.productsMessage';
  const message = error.planName
    ? t(base, { plan: error.planName, limit: error.limit })
    : t(`${base}NoPlan`, { limit: error.limit });

  return (
    <Alert
      severity="warning"
      role="alert"
      action={
        <>
          <Button color="inherit" size="small" onClick={() => navigate('/app/billing')}>
            {t('productBrowser.syncCap.cta')}
          </Button>
          <Button color="inherit" size="small" onClick={onDismiss}>
            {t('productBrowser.syncCap.dismiss')}
          </Button>
        </>
      }
      sx={{ mx: { xs: 1.5, sm: 3 }, mt: 2, alignItems: 'center' }}
    >
      {message}
    </Alert>
  );
}
